import { DEVICE_FEATURE_TYPES, DEVICE_FEATURE_CATEGORIES } from '../../../../../server/utils/constants';
import { TelevisionPushButtonFeatureTypes } from '../../../utils/consts';

const SUPPORTED_FEATURE_TYPES = [
  DEVICE_FEATURE_TYPES.LIGHT.BINARY,
  DEVICE_FEATURE_TYPES.LIGHT.COLOR,
  DEVICE_FEATURE_TYPES.LIGHT.BRIGHTNESS,
  DEVICE_FEATURE_TYPES.LIGHT.TEMPERATURE,
  DEVICE_FEATURE_TYPES.SWITCH.DIMMER,
  DEVICE_FEATURE_TYPES.SWITCH.TARGET_CURRENT,
  DEVICE_FEATURE_TYPES.TELEVISION.CHANNEL,
  DEVICE_FEATURE_TYPES.TELEVISION.VOLUME,
  DEVICE_FEATURE_TYPES.SHUTTER.POSITION,
  DEVICE_FEATURE_TYPES.SHUTTER.STATE,
  DEVICE_FEATURE_TYPES.THERMOSTAT.TARGET_TEMPERATURE,
  DEVICE_FEATURE_TYPES.THERMOSTAT.MODE,
  DEVICE_FEATURE_TYPES.THERMOSTAT.PRESET,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.MODE,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.TARGET_TEMPERATURE,
  DEVICE_FEATURE_TYPES.FAN.MODE,
  DEVICE_FEATURE_TYPES.FAN.PERCENT,
  DEVICE_FEATURE_TYPES.FAN.SPEED,
  DEVICE_FEATURE_TYPES.FAN.AIRFLOW_DIRECTION,
  DEVICE_FEATURE_TYPES.FAN.ROCK_SETTING,
  DEVICE_FEATURE_TYPES.FAN.WIND_SETTING,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.FAN_SPEED,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.SWING_HORIZONTAL,
  DEVICE_FEATURE_TYPES.AIR_CONDITIONING.SWING_VERTICAL,
  DEVICE_FEATURE_TYPES.LOCK.BINARY,
  DEVICE_FEATURE_TYPES.LOCK.STATE,
  DEVICE_FEATURE_TYPES.HEATER.PILOT_WIRE_MODE,
  DEVICE_FEATURE_TYPES.SIREN.LMH_VOLUME,
  DEVICE_FEATURE_TYPES.SIREN.MELODY,
  DEVICE_FEATURE_TYPES.SIREN.ALARM_MODE,
  DEVICE_FEATURE_TYPES.DURATION.DECIMAL,
  DEVICE_FEATURE_TYPES.BUTTON.PUSH,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.CHARGE_ON,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.TARGET_CHARGE_LIMIT,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CHARGE.TARGET_CURRENT,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CLIMATE.CLIMATE_ON,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_CLIMATE.TARGET_TEMPERATURE,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_COMMAND.ALARM,
  DEVICE_FEATURE_TYPES.ELECTRICAL_VEHICLE_COMMAND.LOCK
];

// Some feature types are only supported for a given category, because the type string alone is
// ambiguous (television "play" and music "play" share the same type). They are listed here so that
// they don't leak into every other category.
const SUPPORTED_FEATURE_TYPES_BY_CATEGORY = {
  [DEVICE_FEATURE_CATEGORIES.TELEVISION]: TelevisionPushButtonFeatureTypes,
  [DEVICE_FEATURE_CATEGORIES.CAMERA]: [
    DEVICE_FEATURE_TYPES.CAMERA.ENABLED,
    DEVICE_FEATURE_TYPES.CAMERA.MOVE,
    DEVICE_FEATURE_TYPES.CAMERA.PRESET
  ],
  [DEVICE_FEATURE_CATEGORIES.WATER_HEATER]: [
    DEVICE_FEATURE_TYPES.WATER_HEATER.BINARY,
    DEVICE_FEATURE_TYPES.WATER_HEATER.MODE,
    DEVICE_FEATURE_TYPES.WATER_HEATER.TARGET_TEMPERATURE,
    DEVICE_FEATURE_TYPES.WATER_HEATER.BOOST
  ],
  [DEVICE_FEATURE_CATEGORIES.TEXT]: [DEVICE_FEATURE_TYPES.TEXT.SELECT],
  // The controls of a music player the room widget can render as a row: a play/pause switch,
  // two on/off toggles and the repeat mode. The seek position and the catalog belong to the
  // music box (capabilities/music.md, section 6).
  [DEVICE_FEATURE_CATEGORIES.MUSIC]: [
    DEVICE_FEATURE_TYPES.MUSIC.PLAYBACK_STATE,
    DEVICE_FEATURE_TYPES.MUSIC.SHUFFLE,
    DEVICE_FEATURE_TYPES.MUSIC.REPEAT,
    DEVICE_FEATURE_TYPES.MUSIC.MUTE
  ],
  // Hushing a detector is a control, but scoped to its category: it must never be picked up by
  // the generic switch handling (quick actions, "turn everything off"…)
  [DEVICE_FEATURE_CATEGORIES.SMOKE_SENSOR]: [DEVICE_FEATURE_TYPES.SMOKE_SENSOR.TEMPORARY_MUTE]
};

const isSupportedFeature = ({ category, type }) =>
  SUPPORTED_FEATURE_TYPES.includes(type) || (SUPPORTED_FEATURE_TYPES_BY_CATEGORY[category] || []).includes(type);

export { SUPPORTED_FEATURE_TYPES, isSupportedFeature };
export default isSupportedFeature;
